import React, { FC, useEffect, useMemo, useState } from 'react'
import PopupContainer from 'src/component/popup/PopupContainer'
import TabSwitch from 'src/component/TabSwitch'
import { useGet } from 'src/hooks/useGet'
import { GetAvailableServices, SubmitNewMedicalServices } from 'src/requests/PatientMedicalServices'
import { errorToaster } from 'src/utils'
import AnalisysSection from './DynamisServiceCard'
import DynamisServiceCard from './DynamisServiceCard'
import { useMutation } from 'src/hooks/useMutation'
import { SubmitNewDecisionMedicines } from 'src/requests/DecisionMedicine'

interface IMedicalServicesPopup {
    decisionId: number | null
    modalId: any
    setDecisionId: any
    hospitalId: number | null
}

const medicalService = 'medicalService'


const Tab = {
    Analysis: 2,
    Scan: 3

}

const screenTabs = [
    { label: "Analysis", value: Tab.Analysis },
    { label: "Scan", value: Tab.Scan },

]

const MedicalServicesPopup: FC<IMedicalServicesPopup> = ({ setDecisionId, decisionId, hospitalId, modalId }) => {

    const [activeTab, setActiveTab] = useState()
    const [data, setData] = useState({ analysis: [{ notes: "", hospitalMedicalServiceId: null }], scan: [{ notes: "", hospitalMedicalServiceId: null }] })

    const { mutate } = useMutation()

    const { data: medicialServices } = useGet({ API: GetAvailableServices, isNotValid: !hospitalId, depArr: [hospitalId], params: [hospitalId], defaultValue: [] })

    const analysisService = useMemo(() => medicialServices?.filter((item: any) => item.medicalServiceTypeId == Tab?.Analysis), [medicialServices])
    const scanService = useMemo(() => medicialServices?.filter((item: any) => item.medicalServiceTypeId == Tab?.Scan), [medicialServices])

    const handleSubmit = () => {
        let isAnaysisListEmpty = (data?.analysis.some((item: any) =>  !item?.hospitalMedicalServiceId) && data.analysis.length > 1) || (data?.analysis.some((item: any) =>  !item?.hospitalMedicalServiceId) && data.analysis.length == 1)
        let isScanListEmpty = (data?.scan.some((item: any) =>  !item?.hospitalMedicalServiceId) && data.scan.length > 1) || (data?.scan.some((item: any) =>  !item?.hospitalMedicalServiceId) && data.scan.length == 1)

        if (isAnaysisListEmpty && isScanListEmpty) return errorToaster("add-item-atlist")

        let reqList = [...data?.analysis, ...data?.scan].filter((item: any) => item?.hospitalMedicalServiceId?.value).map((item: any) => ({
            notes: item?.notes,
            hospitalMedicalServiceId: item?.hospitalMedicalServiceId?.value
        }))

        let requestBody = {
            decisionId,
            medicalServices: reqList
        }

        let ReuqestObject = {
            apiMethod: SubmitNewMedicalServices,
            body: requestBody,
            actionType: 'post',
            id: null,
            onSuccess: () => onSuccess(),
            name: "add-medical-service",
        }
        //@ts-ignore
        mutate(ReuqestObject)
    }
    const onSuccess = () => {
        modalId.current.click()
        setData({
            //@ts-ignore
            analysis: [{ notes: "", hospitalMedicalServiceId: null }],
            //@ts-ignore
            scan: [{ notes: "", hospitalMedicalServiceId: null }]
        })
        setDecisionId(null)
    }

    const handleReset = () => {
        setData({
            //@ts-ignore
            analysis: [{ notes: "", hospitalMedicalServiceId: null }],
            //@ts-ignore
            scan: [{ notes: "", hospitalMedicalServiceId: null }]
        })
    }


    useEffect(() => {

        setData({
            //@ts-ignore
            analysis: [{ notes: "", hospitalMedicalServiceId: null }],
            //@ts-ignore
            scan: [{ notes: "", hospitalMedicalServiceId: null }]
        })
    }, [decisionId, hospitalId])

    return (
        <PopupContainer resetAllFields={handleReset} Name='add-medical-service' recordID={decisionId} modalID={modalId} modalName={medicalService} onApply={handleSubmit}>

            <TabSwitch Tabs={screenTabs} defaultSelect={0} setTab={setActiveTab} />

            {activeTab == Tab.Analysis ?
                <DynamisServiceCard decisionId={decisionId} setDecisionId={setDecisionId} fieldName={"analysis"} options={analysisService} data={data} setData={setData} /> : ""
            }
            {activeTab == Tab.Scan ?
                <DynamisServiceCard decisionId={decisionId} setDecisionId={setDecisionId} fieldName={"scan"} options={scanService} data={data} setData={setData} /> : ""
            }

        </PopupContainer>
    )
}

export default MedicalServicesPopup